function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftAlignBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11772"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3219",
    transform: "translate(3 1)",
    style: {
      fill: "#203662"
    },
    d: "M0 0h7v1H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3220",
    transform: "translate(3 4)",
    style: {
      fill: "#203662"
    },
    d: "M0 0h5v1H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3221",
    transform: "translate(3 7)",
    style: {
      fill: "#203662"
    },
    d: "M0 0h7v1H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3222",
    transform: "translate(3 10)",
    style: {
      fill: "#203662"
    },
    d: "M0 0h5v1H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3223",
    style: {
      fill: "#203662"
    },
    d: "M0 0h1v12H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftAlignBlue);
export default __webpack_public_path__ + "static/media/LeftAlignBlue.b1daecf6b1b46c55b20e9c0ee2bd7038.svg";
export { ForwardRef as ReactComponent };